import React from "react"
import { UnorderedListItem, UnorderedList, Typography, ListItemText } from "@carrotfertility/carotene-core"
import { SPRINTS_MESSAGES } from "#/features/sprints-landing/en-only-text"

const gettingStartedItems = [
  {
    id: "boost-natural-fertility",
    title: SPRINTS_MESSAGES.gettingStarted.boostFertility.title,
    description: SPRINTS_MESSAGES.gettingStarted.boostFertility.description
  },
  {
    id: "fewer-fertility-treatments",
    title: SPRINTS_MESSAGES.gettingStarted.fewerFertilityTreatments.title,
    description: SPRINTS_MESSAGES.gettingStarted.fewerFertilityTreatments.description
  },
  {
    id: "support-male-fertility",
    title: SPRINTS_MESSAGES.gettingStarted.supportMaleFertility.title,
    description: SPRINTS_MESSAGES.gettingStarted.supportMaleFertility.description
  },
  {
    id: "healthier-pregnancy-outcomes",
    title: SPRINTS_MESSAGES.gettingStarted.healthierPregnancyOutcomes.title,
    description: SPRINTS_MESSAGES.gettingStarted.healthierPregnancyOutcomes.description
  }
]

export function GettingStartedList() {
  return (
    <div>
      <Typography variant="h5">{SPRINTS_MESSAGES.gettingStarted.title}</Typography>
      <UnorderedList>
        {gettingStartedItems.map((item) => (
          <UnorderedListItem key={item.id}>
            <ListItemText
              primary={
                <Typography component="span" sx={{ fontWeight: "bold !important" }} variant="body1">
                  {item.title}
                </Typography>
              }
              secondary={item.description}
            />
          </UnorderedListItem>
        ))}
      </UnorderedList>
    </div>
  )
}
